import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionToken: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSessionToken: (state, action) => {
      state.sessionToken = action.payload;
    }
  }
});

export const { setSessionToken } = userSlice.actions;
export default userSlice.reducer; 